import React from "react";
import { NavLink } from "react-router-dom";

function CarsActions() {
  return (
    <nav className="uk-position-relative" aria-label="Breadcrumb">
      <ul className="uk-breadcrumb">
        <li>
          <NavLink to="/Cars">السيارات</NavLink>
        </li>
        <li>
          <span aria-current="page">كل السيارات</span>
        </li>
      </ul>
      <div className="uk-position-left">
        <NavLink
          to="/Cars/AddCar"
          className="uk-button uk-button-primary uk-button-small uk-border-rounded uk-margin-small-left"
        >
          <span className="uk-margin-small-left" uk-icon="plus"></span>
          إنشاء
        </NavLink>
        <NavLink
          to="/Cars/RefreshPrices"
          className="uk-button uk-button-secondary uk-button-small uk-border-rounded"
        >
          <span className="uk-margin-small-left" uk-icon="refresh"></span>
          تحديث الأسعار
        </NavLink>
      </div>
    </nav>
  );
}

export default CarsActions;
